"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _callee;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _deleteActivity = _interopRequireDefault(require("../actions/deleteActivity"));

var _incomingActivity = require("../actions/incomingActivity");

var _marked =
/*#__PURE__*/
_regenerator["default"].mark(_callee),
    _marked2 =
/*#__PURE__*/
_regenerator["default"].mark(removeActivityAfterInterval);

function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}

function _callee() {
  return _regenerator["default"].wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.takeEvery)(function (_ref) {
            var type = _ref.type,
                payload = _ref.payload;
            return type === _incomingActivity.INCOMING_ACTIVITY && payload.activity.type === 'typing';
          }, removeActivityAfterInterval);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function removeActivityAfterInterval(_ref2) {
  var id;
  return _regenerator["default"].wrap(function removeActivityAfterInterval$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          id = _ref2.payload.activity.id;
          _context2.next = 3;
          return (0, _effects.call)(sleep, 5000);

        case 3:
          _context2.next = 5;
          return (0, _effects.put)((0, _deleteActivity["default"])(id));

        case 5:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}